type QAItem = { text: string; msg: string }

// quick_actions 卡型：网页端操作台/设置/选项卡——按钮=替用户说出那句话,点击即发送
export function QuickActionsCard({ title, items, onPick }: { title: string; items?: QAItem[]; onPick: (msg: string) => void }) {
  if (!items || items.length === 0) return null
  return (
    <div className="my-2 rounded-xl border border-gray-100 bg-white p-3 shadow-sm">
      <div className="mb-2 text-xs font-medium text-gray-500">{title}</div>
      <div className="flex flex-wrap gap-1.5">
        {items.map((it, k) => (
          <button key={k} onClick={() => onPick(it.msg || it.text)}
            className="rounded-lg border border-indigo-100 bg-indigo-50/60 px-2.5 py-1 text-xs text-indigo-700 hover:bg-indigo-100">{it.text}</button>
        ))}
      </div>
    </div>
  )
}
